/**
 * Preferred order for recharge sales types in the UI (RECHARGE SALES first).
 */
const RECHARGE_SALES_ORDER = [
  "RECHARGE SALES",
  "THROUGH FOS",
  "DIRECTLY TO RETAILERS",
];

const DEFAULT_ROW = {
  actualValue: "0",
  planValue: "0",
  lmtdVal: "0",
  percentAchieved: "0.0",
};

/**
 * Normalizes API content into the shape expected by PrimarySalesView:
 * { salesWrapper: { "RECHARGE SALES": {...}, "THROUGH FOS": {...}, "DIRECTLY TO RETAILERS": {...} } }
 * with RECHARGE SALES first in key order.
 * @param {*} raw - API response content (array of items, or object keyed by rechargeType, or { salesWrapper })
 * @returns {{ salesWrapper: Object } | undefined}
 */
export function normalizeRechargeSalesData(raw) {
  if (raw == null) return undefined;

  let byType = {};

  if (raw.salesWrapper && typeof raw.salesWrapper === "object") {
    byType = { ...raw.salesWrapper };
  } else if (Array.isArray(raw)) {
    raw.forEach((item) => {
      if (item == null) return;
      const type = (item.rechargeType || item.recharge_type || item.type || "").toString().trim();
      if (!type) return;
      byType[type.toUpperCase()] = toRow(item, type);
    });
  } else if (typeof raw === "object") {
    Object.entries(raw).forEach(([key, item]) => {
      const type = key.trim().toUpperCase();
      if (!type) return;
      byType[type] = toRow(item, key);
    });
  }

  if (Object.keys(byType).length === 0) return undefined;

  const salesWrapper = {};
  RECHARGE_SALES_ORDER.forEach((preferredKey) => {
    const existingKey = Object.keys(byType).find((k) => k.toUpperCase() === preferredKey);
    if (existingKey) {
      salesWrapper[preferredKey] = { ...byType[existingKey], rechargeType: preferredKey };
    }
  });
  Object.entries(byType).forEach(([key, value]) => {
    if (!RECHARGE_SALES_ORDER.some((p) => p.toUpperCase() === key.toUpperCase())) {
      salesWrapper[key] = value;
    }
  });

  return { salesWrapper };
}

function toRow(item, typeLabel) {
  if (item == null) return { ...DEFAULT_ROW, rechargeType: typeLabel };
  const type = (item.rechargeType || item.recharge_type || typeLabel || "").toString();
  return {
    actualValue: String(item.actualValue ?? item.actual_value ?? item.achieved ?? DEFAULT_ROW.actualValue),
    planValue: String(item.planValue ?? item.plan_value ?? item.target ?? DEFAULT_ROW.planValue),
    lmtdVal: String(item.lmtdVal ?? item.lmtd_val ?? item.lmtd ?? DEFAULT_ROW.lmtdVal),
    percentAchieved: String(item.percentAchieved ?? item.percent_achieved ?? item.percent ?? DEFAULT_ROW.percentAchieved),
    rechargeType: type,
  };
}
